/* eslint-disable react/no-multi-comp */
import React, { useRef, useState } from "react"
import { Button } from "@components/shared"
import { CONSTANTS } from "@data"
import { Link } from "gatsby"
import Styles from "./alertBanner.module.scss"

const AlertBanner = props => {
  const { theme, data } = props

  const { COLORS } = CONSTANTS

  const alertHolderRef = useRef(null)

  const [open, setOpen] = useState(true)

  const outsideClickListener = event => {
    if (event.target === alertHolderRef.current) {
      // eslint-disable-next-line no-use-before-define
      onClose()
    }
  }
  const onClose = () => {
    alertHolderRef.current.removeEventListener("click", outsideClickListener)
    setOpen(false)
  }

  return (
    <div
      ref={alertHolderRef}
      className={`${Styles.alert} ${open ? Styles.fadeIn : Styles.fadeOut}`}
    >
      <button
        type="button"
        className={Styles.closeButton}
        onClick={onClose}
        aria-expanded={open}
        // aria-controls={objs.demoContent}
        aria-label="Close Alert"
      >
        <span className={Styles.closeWrapper}>
          <span className={`${Styles.closeItem} ${Styles.closeOne}`} />
          <span className={`${Styles.closeItem} ${Styles.closeTwo}`} />
        </span>
      </button>
      <div className={Styles.container}>
        <div className={Styles.bodyCopy}>{data.bodyCopy}</div>
        <div className={Styles.ctaHolder}>
          <Link to={data.ctaLink} target="_blank">
            {" "}
            <Button
              className={Styles.ctaButton}
              filled
              theme={theme}
              color={COLORS.ALERT}
              type="submit"
              displayCTA
            >
              <div className={Styles.ctaCopy}>{data.ctaText}</div>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AlertBanner
